import React from "react";
import Hero from "../Hero";
import AboutSection from "../Section/AboutSection";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle"; 
import { NewProductsLayout } from "../Section/DepartmentSection/NewProductsLayout";
import { Helmet } from "react-helmet-async";

 
const departmentData = [
  {
    title: "Hyper-Hypothermia Unit 1 Plus (Patent applied for)",
    // iconUrl: "images/home_1/Hyper Hypothermia Unit.png",
    iconUrl: "images/departments/Hyper-Hypothermia Unit 1 Plus.png",

    href: "/HyperHypothermiaUnit",
    images: [
      "images/HyperPlus/Hyper-Hypothermia Unit 1 Plus.png",
      "images/HyperPlus/Hyper-Hypothermia Unit 1 Plus (2).png",

      "images/HyperPlus/Hyper-Hypothermia Unit 1 Plus (3).png",
      "images/HyperPlus/Hyper-Hypothermia Unit 1 Plus (4).png",
    ],

    datalist: [
      "Faster Cooling and heating in it's class",
      " Graphical User Interface",
      "  Fully Touch Controller Display",
      "  Diagnostic Mode",
      " Emergency Manual Mode",
      "  Custom Configuration",
      "Reconfigurable according to customers need",
      "Auto-Cleaning Mode",
      " Independent Operation",
      " The Unit Offers Additional Feature",
    ],
  },
  {
    title: "Hyper-Hypothermia Unit 1 (Patent applied for)",
    // iconUrl: "images/home_1/Hyper Hypothermia Unit.png",
    iconUrl: "images/HomeProducts/Hyper-Hypothermia Unit.png",

    href: "/HyperHypothermiaUnitplus",
    images: [
      "images/HyperHypoThemia/Hyper-Hypothermia Unit.png",
      "images/HyperHypoThemia/Hyper-Hypothermia Unit-2.png",

      "images/HyperHypoThemia/fast.png",
      "images/HyperHypoThemia/fast.png",
    ],

    datalist: [
      "Faster Cooling and heating in it's class",
      "Fully touch screen control",
      " Auto-Cleaning Mode for descaling & disinfecting",
      " Easy to use graphical user interface",
      " Introducing first ever diagnostic mode of its kind",
      " Introducing first ever manual mode for emergency use",
      "Reconfigurable according to customers need",
      " Independent cooling and heating for both the patient and cardioplegia circuits",
      " Silent Operation compare to other similar equipment",
      " Robust electronic architecture for minimal electronic failure",
    ],
  },

  {
    title: "Mercury Mini",
    // iconUrl: "images/home_1/MERCURY MINI.png",
    iconUrl: "images/HomeProducts/Mercury Mini.png",

    href: "/MercuryMini",

    images: [
      "images/MercuryMini/Mercury Mini.png",
      "images/MercuryMini/Mercury Mini-2.png",
      "images/MercuryMini/IMG_0116.JPG",
      "images/MercuryMini/IMG_0116.JPG",
    ],

    datalist: [
      "Touch screen control.",
      "Portable Heater Unit",
      "5 ltr water capacity. ",
      "Two output circuits.",
      "Open tank. ",
      "Temp range 35°C to 42°C. ",
      "Flow rate is 5 lit/min. ",
      "PLC based electronics. ",
    ],
  },
  {
    title: "Mercury Care",
    // iconUrl: "images/home_1/MERCURY MINI.png",
    iconUrl: "images/departments/Mercury Care.png",

    href: "/Mercurycare",

    images: [
      "images/HyperPlus/Mercury Care.png",
      "images/HyperPlus/Mercury Care (2).png",

      "images/HyperPlus/Mercury Care (3).png",
      "images/HyperPlus/Mercury Care (4).png",
    ],

    datalist: [
      "Fastest Heating and Cooling",
      "Graphical User Interface",
      "Fully Touch Controller Display ",
      " Robust Design",
      " Two Output Circuits ",
      " Auto Mode ",
     
    ],
  },
  {
    title: "Mercury Magma",
    // iconUrl: "images/home_1/Mercury Magma.png",
    iconUrl: "images/HomeProducts/Mercury Magma.png",

    href: "/MercuryMagma",
    images: [
      "images/MercuryMagma/magma11.png",
      "images/MercuryMagma/Mercury Magma-2.png",
      "images/MercuryMagma/Mercury Magma-3.png",
      "images/MercuryMagma/Mercury Magma.png",
    ],
    datalist: [
      "Open Tank",
      "5 lit Water Capacity",
      "Single Output Circuit",
      "Touch Screen Control",
      "Temp Range 42° to 55° C",
      "Flow Rate > 5 lit/Min",
      "PLC Based Electronics",
    ],
  },
  {
    title: "Mercury Slush",
    // iconUrl: "images/home_1/Mercury Slush.png",
    iconUrl: "images/HomeProducts/Mercury Slush.png",
    href: "/MercurySlush",
    images: [
      "images/HomeProducts/Mercury Slush.png",
      "images/HomeProducts/Mercury Slush.png",
      "images/HomeProducts/Mercury Slush.png",
      "images/HomeProducts/Mercury Slush.png",
    ],
    datalist: [
      "Open Tanks",
      "Minimize the Risk of Trauma to delicate Tissues and Organs",
      "Save Valuable Nursing Time",
      "Easy To Operate And Maintain",
      "Slush Basin With Auto - Stir",
      "Silent Operation",
    ],
  },
  {
    title: "Mercury-S1-Sternum-Saw",
    // iconUrl: "images/home_1/S1  Sternum Saw.png",
    iconUrl: "images/HomeProducts/Mercury-S1-Sternum-Saw.png",

    href: "/Mercury-S1-Sternum-Saw",
    images: [
      " images/Sternum-Saw/Mercury-S1-Sternum-Saw-1.png",
      "images/Sternum-Saw/Mercury-S1-Sternum-Saw.png",
      "images/Sternum-Saw/Mercury-S1-Sternum-Saw.png",
      "images/Sternum-Saw/Mercury-S1-Sternum-Saw.png",
    ],
    datalist: [
      "Cutting Edge Technology With Clear Line Of Sight",
      "LightWeight Design Provides Exceptional Control ",
      "Sharp Single-Use Blade ",
      "Reversible Blade Design Allows Cutting in Both Direction",
    ],
  },
  {
    title: "Mercury Micro-Portable ECMO Heater",
    // iconUrl: "images/home_1/S1  Sternum Saw.png",
    iconUrl: "/images/MercuryMicro/Mercury MicroNew.png",

    href: "/MercuryMicro",
    images: [
      "/images/MercuryMicro/Mercury Micro.png",
      "/images/MercuryMicro/Mercury Micro (2).png",
      "/images/MercuryMicro/Mercury Micro (3).png",
      "/images/MercuryMicro/Mercury Micro (4).png",
    ],
    datalist: [
      "Touch Control Display",
      " PLC based electronics ",
      " Unit operates on 230V / 50Hz",
      "YSI 400 type temp port",
      "Closed tank unit with 3Lit water capacity",
      " Single Out put circuit",
      "Flow rate 5lit / min",
      "Apprx 12kg weight",

      "L 38 x H 25.5 x W19.5 cms",
      // "Temp Range - 35 to 42C",
    ],
  },
];

export default function Home() {
  pageTitle("Home");

  return (
    <>
      <Helmet>
        <title>Hyper-Hypothermia Unit Manufacture and Supplier | Mercuryhc Pvt Ltd</title>
        <meta name="description" content="Mercury Healthcare is one of the leading Hyper-Hypothermia Machine Exporters, Manufacture and Supplier based in India. We export Medical Equipment to Argentina, USA, UAE, Europe and other countries of the world." />
        <meta name="Keyword" content="Perfusion Machine Manufacturer, Mercuryhc, Heater cooler machine, Heater cooler unit, Hyper-Hypothermia Machine, Mercury Healthcare, Medical Equipment suppliers, Medical Equipment Manufacturing, Fast Cooling machine, Hyper-Hypothermia Machine Manufacture, Hyper-Hypothermia Machine Supplier," />
        <meta name="google-site-verification" content="Vre5v1kRPnoDeZODhI5OfgXyjI14_QnTIqXIyoWbjGQ" />
        {/* Google Analytics */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-MGF4V7P4YB"></script>
        <script>
          {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-MGF4V7P4YB');
    `}
        </script>
      </Helmet>

      <Hero
        title="Leading Critical<br> Care Solutions"
        subTitle="Precision medical equipment for better care and outcomes, including Hyper-Hypothermia Units and advanced surgical tools."
        bgUrl="/images/home_1/hero_bg.jpeg"
        imgUrl="/images/home_1/NewProductsbanner2025.png"
        // imgUrl="/images/home_1/ProductsBanner.png"
        videoBtnText="See how we work"
        videoUrl="https://www.youtube.com/embed/dGYQWvpaB-c?feature=oembed"
      // infoList={[
      //   {
      //     title: 'Hotline',
      //     subTitle: '123-456-7890',
      //     iconUrl: '/images/contact/icon_1.svg',
      //   },
      //   {
      //     title: 'Ambulance',
      //     subTitle: '876-256-876',
      //     iconUrl: '/images/icons/ambulance.svg',
      //   },
      //   {
      //     title: 'Location',
      //     subTitle: 'New York, US',
      //     iconUrl: '/images/icons/pin.svg',
      //   },
      // ]}
      // btnText="Book Now"
      // btnUrl="/appointments"
      />
      {/* Start About Section */}
      <Section>
        <AboutSection
          // imgUrl="/images/about/6.png"
          imgUrl="/images/about/6.png"
          // spiningImgUrl="/images/home_1/about_mini.svg"
          spiningImgUrl="/images/home_1/Mercury-HC.png"
          title="About Us"
          subTitle="MERCURY HEALTHCARE"
          featureList={[
            {
              featureListTitle: "Expertise in Innovation",
              featureListSubTitle:
                "At Mercury Healthcare, our team combines deep medical expertise with cutting-edge technology. We innovate to deliver advanced medical equipment that sets new standards for care and reliability, ensuring the highest level of patient outcomes and clinical efficiency.",
            },
            {
              featureListTitle: "Precision in Healthcare",
              featureListSubTitle:
                "Mercury Healthcare leads the way in creating precise, reliable medical equipment. Our commitment to quality and innovation ensures our products meet the highest standards, enhancing patient care and operational efficiency globally.",
            },
          ]}
        />
      </Section>
      {/* End About Section */}

      {/* Start Departments Section */}
      <Section topMd={185} topLg={150} topXl={50}>
        <NewProductsLayout
          sectionTitle="Our Products"
          subsectiontitle="Why Mercury products?"
          subsectionpara="Mercury products stand out for their innovation, precision, and reliability. Designed with advanced technology and expert engineering, our medical equipment ensures superior performance, enhancing patient care and operational efficiency."
          data={departmentData}
        />
      </Section>
      {/* End Departments Section */}

      {/* Start Award Section */}
      {/* <Section topMd={185} topLg={50} topXl={100}>
     
        <BrandsCarousel sectionTitle="Business Association" data={awardData} />

      </Section> */}
      {/* End Award Section */}

      {/* Start Testimonial */}
      {/* <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSection
          sectionTitle="Some Testimonials"
          sectionTitleDown="Of our clients"
        />
      </Section> */}
      {/* End Testimonial */}

      {/* Start Blog Section */}
      {/* <Section topMd={190} topLg={145} topXl={50}>
        <BlogSection sectionTitle="Certifications" data={blogData} />
      </Section> */}
      {/* End Blog Section */}

      {/* Start Feature Section */}
      {/* <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection sectionTitle="Our Values" data={featureListData} />
      </Section> */}
      {/* End Feature Section */}

      {/* Start Appointment Section */}
      {/* <Section topMd={190} topLg={145} topXl={105} id="appointment">
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/home_1/appointment.jpeg"
        />
      </Section> */}
      {/* End Appointment Section */}

      {/* Start FAQ Section */}
      {/* <Section topMd={190} topLg={145} topXl={105}>
        <FaqSection
          data={faqData}
          sectionTitle="Usually Asked"
          sectionTitleUp="What People"
        />
      </Section> */}
      {/* End FAQ Section */}

      {/* Start Brand Section */}
      {/* <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <BrandsSection sectionTitle="Certifications" data={brandData} />
      </Section> */}
      {/* End Brand Section */}
    </>
  );
}



